// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3870":"f804a813","12155":"f804a813","23677":"d3b8bae2","25852":"5a1e6a51","26346":"280c13aa","47305":"d3b8bae2","80208":"4545b38d","95377":"4545b38d"}[chunkId] + ".chunk.css";
};